import React, { useState, useRef, useEffect, useCallback } from "react";
import { useFetchCustomerNotesColorDataQuery, useFetchTaskDataQuery } from "../../../../utils/customer/customerSelect";
import useRequireAuth from "../../../../utils/useRequireAuth";
import { useDispatch, useSelector } from "react-redux";
import { saveNotes } from "../../../../utils/customer/customerNotesSlice";
import CustomerNameNotesEditor from "./CustomerNameNotesEditor";
import useClickOutside from "../../../../hooks/Screen/useClickOutside";
import {
  useLazyFetchCustomerNotesTableDataQuery,
  usePostApiMutation,
  usePostNoteAttachmentMutation,
} from "../../../../utils/customer/customerTaskTable";
import { CUSTMOER_NOTES_DATA_GET, CUSTOMER_NOTES_ADD_UPDATE } from "../../../../utils/constants";
import { getCommonDataBasedOnId } from "../../../store/customer/CustomerSocialAddUpdateFunction";
import useKeyboardShortcuts from "../../../../hooks/KeysHandle/useKeyboardShortcuts";
import NotesModal from "./NotesModal";
import { pushAlert } from "../../../../utils/alertSlice";
import { getFormData } from "../../../../utils/utilityFunctions/stringUtility";
import { hideLoader, showLoader } from "../../../../utils/loaderSlice";

const ViewNotesDrawer = ({ Item, isOpen, isCustomModule, handleCloseNotes, refetch, sectionType = "Tracking" }) => {
  const { token } = useRequireAuth();
  const dispatch = useDispatch();
  const [notesSetting, setNotesSetting] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const textareaRef = useRef(null);
  const popupRef = useRef(null);
  const [notesData, setNotesData] = useState([]);
  const [rawNotesData, setRawNotesData] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);

  const [viewNotes, setViewNotes] = useState({
    allnotes: false,
    addnotes: false,
  });

  const [initialContent, setInitialContent] = useState("");
  const [addNotes, setAddNotes] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);

  const [colour, setColor] = useState("#FF0000");
  const [formData, setFormData] = useState({
    notes_title: "",
    notes_category_id: "",
    colour_code: "",
  });

  const {
    data: customerColor,
    error: customerCodeerror,
    isLoading: customerColorLoading,
  } = useFetchCustomerNotesColorDataQuery({
    token,
  });
  console.log("ItemCalled", Item);

  const handleInputChange = (e) => {
    // e.preventDefault();
    // e.stopPropagation();
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  console.log(selectedOptions, "formselectedOptions");

  const handleSetColour = (colour) => {
    setColor(colour);
  };

  const [NotesFetchDataLazy, { refetch: refetchCustomerNotesData }] = useLazyFetchCustomerNotesTableDataQuery();

  const [
    AddUpdateNotes,
    {
      data: NotesAddUpdateData,
      isError: NotesAddUpdateError,
      isSuccess: NotesAddUpdateSuccess,
      isLoading: NotesAddUpdateLoading,
    },
  ] = usePostApiMutation();

  const handleNotesClick = async (key) => {
    setViewNotes({ allnotes: true, addnotes: true });

    let data = {
      customerId: Item?.id,
      template_id: Item?.template_id,
    };

    if (isCustomModule) {
      data.row_id = Item?.row_id;
    }

    await NotesFetchDataLazy(data)
      .unwrap()
      .then((response) => {
        setNotesData(response?.data?.notes);
        setRawNotesData(response?.data);
      })
      .catch((error) => {
        dispatch(pushAlert({ visible: true, message: error, type: "danger" }));
        console.error("Error fetching customer notes data:", error);
      });
  };

  useEffect(() => {
    handleNotesClick();
  }, []);

  useEffect(() => {
    //loading
    if (NotesAddUpdateLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
    //try block
    if (NotesAddUpdateSuccess) {
      setAddNotes(false);
      dispatch(
        pushAlert({
          message: NotesAddUpdateData?.success ? NotesAddUpdateData?.msg : "something went wrong",
          type: NotesAddUpdateData?.success ? "success" : "danger",
          visible: true,
        })
      );
      if (NotesAddUpdateData.success) {
        setFormData({ notes_title: "", notes_category_id: "", colour_code: "" });
        handleNotesClick();
        resetFile();
        setRefreshKey((prevKey) => prevKey + 1);
      }
    }
    // catch block
    if (NotesAddUpdateError) {
      dispatch(pushAlert({ message: "Something went wrong", type: "danger", visible: true }));
    }
  }, [NotesAddUpdateLoading, NotesAddUpdateSuccess, NotesAddUpdateError]);

  // const handleCloseNotes = () => {
  //   handleCloseNotes()
  // };

  const closenotesoutsideclick = useClickOutside(() => {
    handleCloseNotes();
  });

  const [
    postNoteAttachment,
    {
      isLoading: postNoteAttachmentLoading,
      isSuccess: postNoteAttachmentSuccess,
      isError: postNoteAttachmentError,
      data: postNoteAttachmentData,
    },
  ] = usePostNoteAttachmentMutation();

  const handleFileUpload = async () => {
    const input = document.createElement("input");
    input.type = "file";
    input.multiple = true;
    input.click();

    input.addEventListener("change", async (event) => {
      const files = Array.from(event.target.files);
      let updatedFiles = [...selectedFiles];
      let lastId = selectedFiles.length > 0 ? selectedFiles[selectedFiles.length - 1].id : 0;

      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const formData = new FormData();
        formData.append("file", file);

        try {
          const response = await postNoteAttachment({ data: formData }).unwrap();

          updatedFiles.push({
            id: response.id,
            attachment: response.filename,
            file: file,
            view_url: response.view_url,
            download_url: response.download_url,
            // uploaded_id: response.id, // optional if you want to track server id
          });
        } catch (error) {
          console.error("File upload failed for:", file.name, error);
        }
      }

      setSelectedFiles(updatedFiles);
    });

    return false;
  };

  const resetFile = () => {
    setSelectedFiles([]);
  };

  //const isOpen = () => {};

  const handleClickDeleteFile = (index) => {
    if (index >= 0 && index < selectedFiles?.length) {
      setSelectedFiles((prevFiles) => prevFiles.filter((file, idx) => idx !== index));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const notesData = {
      id: formData?.id,
      notes_category_id: formData?.notes_category_id,
      colour_code: colour ?? "008937",
      notes_title: formData.notes_title,
      company_id: Item?.company_id,
      customer_id: Item?.id,
      notes_body: textareaRef.current.innerHTML,
      rag_status: "wip",
      attachmentIds: selectedFiles.map((file) => file.id),
      tags: selectedOptions,
    };
    console.log("formDatavinay", notesData);
    const formDatanotes = getFormData(notesData);

    if (notesData.notes_title === "") {
      dispatch(pushAlert({ type: "danger", message: "Please add title", visible: true }));
    } else if (notesData.notes_body === "") {
      dispatch(pushAlert({ type: "danger", message: "Please add notes", visible: true }));
    } else {
      try {
        AddUpdateNotes({
          data: notesData,
          url: `${CUSTOMER_NOTES_ADD_UPDATE}?${isCustomModule ? `template_id=${Item?.template_id}&row_id=${Item?.row_id}` : `type=${sectionType}`}`,
        });

        refetch();
      } catch (error) {
        dispatch(hideLoader());
        dispatch(
          pushAlert({
            message: error.message || "Something went wrong",
            type: "danger",
            visible: true,
          })
        );
      }
    }
  };

  const handleClickOutside = (event) => {
    if (popupRef.current && !popupRef.current.contains(event.target)) {
      // closePopup();
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Using the hook to close the div on Escape key press
  useKeyboardShortcuts({
    Escape: handleCloseNotes, // Call handleCloseNotes when Escape is pressed
  });

  const refetchNotesData = async () => {
    handleNotesClick();
  };

  return (
    <>
      {Boolean(Item) && (
        <NotesModal
          isOpen={isOpen}
          closenotesoutsideclick={closenotesoutsideclick}
          Item={Item}
          handleCloseNotes={handleCloseNotes}
          notesData={notesData}
          rawNotesData={rawNotesData}
          refreshKey={refreshKey}
          viewNotes={viewNotes}
          setNotesSetting={setNotesSetting}
          notesSetting={notesSetting}
          handleNotesClick={handleNotesClick}
          selectedFiles={selectedFiles}
          resetFile={resetFile}
          customerColor={customerColor}
          handleSubmit={handleSubmit}
          handleInputChange={handleInputChange}
          formData={formData}
          handleSetColour={handleSetColour}
          // CustomerNameNotesEditor={CustomerNameNotesEditor}
          initialContent={initialContent}
          setInitialContent={setInitialContent}
          handleFileUpload={handleFileUpload}
          handleClickDeleteFile={handleClickDeleteFile}
          refetchNotesData={refetchNotesData}
          refetch={refetch}
          setAddNotes={setAddNotes}
          addNotes={addNotes}
          //setStates pass for preview page
          setFormData={setFormData}
          setColor={setColor}
          textareaRef={textareaRef}
          setSelectedFiles={setSelectedFiles}
          setSelectedOptions={setSelectedOptions}
          selectedOptions={selectedOptions}
          sectionType={sectionType}
          isCustomModule={isCustomModule}
        />
      )}
    </>
  );
};

export default ViewNotesDrawer;
